import history from 'bz-utilities/modules/networking/history/rr4';
import React from 'react';
import { useLocation } from 'react-router';
import Tab from '../tab';

export interface IProps extends React.PropsWithChildren {
  dataTestId?: string;
  route: string;
}

const RoutingTab: React.FC<IProps> = React.memo(({ route, children, ...other }) => {
  const { pathname } = useLocation();

  const isActive: boolean = React.useMemo(() => {
    return pathname.indexOf(route) === 0;
  }, [route, pathname]);

  const onClick = React.useCallback((): void => {
    history.push(route);
  }, [route]);

  return (
    <Tab isActive={isActive} onClick={onClick} {...other}>
      {children}
    </Tab>
  );
});

RoutingTab.displayName = 'RoutingTab';

export default RoutingTab;
